import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, UserRound, FileDown, Mail, RefreshCw } from "lucide-react";
import { api, errMsg, download } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const AvatarButton = ({ c }) => {
  const enter = async () => {
    try {
      await api.post(`/admin/companies/${c.id}/avatar`);
      toast.success(`Modalità Avatar: entri come ${c.denominazione}`);
      window.location.href = "/app";
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Button variant="ghost" size="sm" data-testid={`avatar-company-${c.id}`} disabled={!c.avatar_consenso}
      title={c.avatar_consenso ? "Entra nell'azienda in modalità Avatar" : "L'azienda non ha ancora autorizzato l'accesso Avatar"}
      className={c.avatar_consenso ? "text-emerald-700" : "text-slate-400"} onClick={enter}>
      <UserRound className="mr-1 h-4 w-4" />Avatar
    </Button>
  );
};

const Row = ({ label, value, testid }) => (
  <div className="grid grid-cols-3 gap-2 border-b border-slate-100 py-2 text-sm">
    <span className="text-slate-500">{label}</span><span data-testid={testid} className="col-span-2 break-all font-mono font-semibold">{value || "-"}</span>
  </div>
);

export const CredenzialiButton = ({ c }) => {
  const [cred, setCred] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const open = () => run(async () => setCred((await api.get(`/admin/companies/${c.id}/credenziali`)).data));
  const gen = () => run(async () => {
    if (cred?.password && !window.confirm("Generare una nuova password? Quella attuale non funzionerà più.")) return;
    setCred((await api.post(`/admin/companies/${c.id}/credenziali`)).data); toast.success("Credenziali generate");
  });
  const send = () => run(async () => { setCred((await api.post(`/admin/companies/${c.id}/credenziali/invia`)).data); toast.success("Credenziali inviate per email"); });
  const fmt = (d) => (d ? new Date(d).toLocaleString("it-IT") : "mai");
  return (
    <>
      <Button variant="ghost" size="sm" data-testid={`credentials-company-${c.id}`} onClick={open}><KeyRound className="mr-1 h-4 w-4" />Credenziali</Button>
      <Dialog open={!!cred} onOpenChange={(o) => !o && setCred(null)}>
        <DialogContent data-testid="credentials-dialog">
          <DialogHeader><DialogTitle>Credenziali · {c.denominazione}</DialogTitle></DialogHeader>
          {cred && (
            <div>
              <Row label="Nome utente" value={cred.username} testid="cred-username" />
              <Row label="Password" value={cred.password} testid="cred-password" />
              <Row label="Email" value={cred.email} testid="cred-email" />
              <Row label="Generate il" value={fmt(cred.generate_il)} testid="cred-generated" />
              <Row label="Ultimo invio" value={fmt(cred.inviate_il)} testid="cred-sent" />
              <div className="mt-4 flex flex-wrap gap-2">
                <Button variant="outline" disabled={busy} data-testid="cred-generate" onClick={gen}><RefreshCw className="mr-1 h-4 w-4" />{cred.password ? "Rigenera" : "Genera credenziali"}</Button>
                {cred.password && <Button variant="outline" disabled={busy} data-testid="cred-letter" onClick={() => run(() => download(`/admin/companies/${c.id}/lettera.pdf`))}><FileDown className="mr-1 h-4 w-4" />Lettera PDF</Button>}
                {cred.password && <Button className="bg-sky-600 hover:bg-sky-700" disabled={busy} data-testid="cred-send" onClick={send}><Mail className="mr-1 h-4 w-4" />Invia per email</Button>}
              </div>
              <p className="mt-3 text-xs text-slate-500">L'azienda entra con la partita IVA (preceduta da IT) e questa password. La password è conservata cifrata.</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
